/**
 * customerSettingsSlice — Customer settings (Portal toggles + Tag rules).
 *
 * Hydrated from the live customer-settings API via CustomerSettingsInitializer
 * (seeded server-side by `getCustomerSettingsSSR()`); the forms seed their local
 * state from here and dispatch `setCustomerSettings` with the server-returned
 * value on save.
 */
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import {
  type CustomerSettings,
  defaultCustomerSettings,
} from "@/components/settings/customer/types";

export interface CustomerSettingsState {
  settings: CustomerSettings;
  loading: boolean;
}

const initialState: CustomerSettingsState = {
  settings: defaultCustomerSettings(),
  loading: true,
};

const customerSettingsSlice = createSlice({
  name: "customerSettings",
  initialState,
  reducers: {
    /** Replace the customer settings — used to hydrate from the API on mount. */
    setCustomerSettings(state, action: PayloadAction<CustomerSettings>) {
      state.settings = action.payload;
    },
    setCustomerLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const { setCustomerSettings, setCustomerLoading } =
  customerSettingsSlice.actions;

export default customerSettingsSlice.reducer;
